
export const THEME_COLORS = {

  BLACK: '#000000',
  WHITE: '#FFFFFF',
  

  GRAY_900: '#1a1a1a',  // Almost black
  GRAY_800: '#2a2a2a',  // Dark gray
  GRAY_700: '#404040',  // Medium dark gray
  GRAY_600: '#525252',  // Medium gray
  GRAY_500: '#737373',  // Neutral gray
  GRAY_400: '#9a9a9a',  // Light gray
  GRAY_300: '#d4d4d4',  // Very light gray
  GRAY_200: '#e5e5e5',  // Near white gray
  GRAY_100: '#f5f5f5',  // Very light background
  GRAY_50: '#fafafa',   // Almost white
};


export const SEMANTIC_COLORS = {

  BACKGROUND_PRIMARY: THEME_COLORS.WHITE,
  BACKGROUND_SECONDARY: THEME_COLORS.GRAY_50,
  BACKGROUND_TERTIARY: THEME_COLORS.GRAY_100,
  BACKGROUND_DARK: THEME_COLORS.BLACK,
  BACKGROUND_CARD: THEME_COLORS.WHITE,
  BACKGROUND_OVERLAY: THEME_COLORS.GRAY_800,
  

  TEXT_PRIMARY: THEME_COLORS.BLACK,
  TEXT_SECONDARY: THEME_COLORS.GRAY_600,
  TEXT_MUTED: THEME_COLORS.GRAY_500,
  TEXT_DISABLED: THEME_COLORS.GRAY_400,
  TEXT_ON_DARK: THEME_COLORS.WHITE,
  

  BORDER_PRIMARY: THEME_COLORS.GRAY_300,
  BORDER_SECONDARY: THEME_COLORS.GRAY_200,
  BORDER_FOCUS: THEME_COLORS.BLACK,
  BORDER_HOVER: THEME_COLORS.GRAY_400,
  

  BUTTON_PRIMARY_BG: THEME_COLORS.BLACK,
  BUTTON_PRIMARY_TEXT: THEME_COLORS.WHITE,
  BUTTON_PRIMARY_HOVER: THEME_COLORS.GRAY_800,
  BUTTON_SECONDARY_BG: THEME_COLORS.WHITE,
  BUTTON_SECONDARY_TEXT: THEME_COLORS.BLACK,
  BUTTON_SECONDARY_BORDER: THEME_COLORS.GRAY_300,
  BUTTON_SECONDARY_HOVER: THEME_COLORS.GRAY_50,
  
  
  STATUS_NEW: THEME_COLORS.GRAY_800,
  STATUS_IN_PROGRESS: THEME_COLORS.GRAY_600,
  STATUS_WAITING: THEME_COLORS.GRAY_500,
  STATUS_DONE: THEME_COLORS.GRAY_400,
  
  
  HOVER_LIGHT: THEME_COLORS.GRAY_50,
  HOVER_DARK: THEME_COLORS.GRAY_100,
  ACTIVE_LIGHT: THEME_COLORS.GRAY_100,
  ACTIVE_DARK: THEME_COLORS.GRAY_200,
  FOCUS_RING: THEME_COLORS.GRAY_400,
  
  // Loading and skeleton
  LOADING_PRIMARY: THEME_COLORS.GRAY_400,
  SKELETON_BASE: THEME_COLORS.GRAY_200,
  SKELETON_HIGHLIGHT: THEME_COLORS.GRAY_100,
};


export const THEME_CLASSES = {

  BG_PRIMARY: 'bg-white',
  BG_SECONDARY: 'bg-gray-50',
  BG_TERTIARY: 'bg-gray-100',
  BG_DARK: 'bg-black',
  BG_CARD: 'bg-white',
  BG_OVERLAY: 'bg-gray-800',
  

  TEXT_PRIMARY: 'text-black',
  TEXT_SECONDARY: 'text-gray-600',
  TEXT_MUTED: 'text-gray-500',
  TEXT_DISABLED: 'text-gray-400',
  TEXT_ON_DARK: 'text-white',
  

  BORDER_PRIMARY: 'border-gray-300',
  BORDER_SECONDARY: 'border-gray-200',
  BORDER_FOCUS: 'border-black focus:ring-gray-400',
  BORDER_HOVER: 'hover:border-gray-400',
  
  
  BUTTON_PRIMARY: 'bg-black text-white hover:bg-gray-800 focus:ring-gray-400',
  BUTTON_SECONDARY: 'bg-white text-black border border-gray-300 hover:bg-gray-50 focus:ring-gray-400',
  BUTTON_GHOST: 'bg-transparent text-black hover:bg-gray-100 focus:bg-gray-100',
  
  // Status badges
  STATUS_NEW: 'bg-gray-800 text-white',
  STATUS_IN_PROGRESS: 'bg-gray-600 text-white',
  STATUS_WAITING: 'bg-gray-500 text-white',
  STATUS_DONE: 'bg-gray-400 text-white',
  
  
  HOVER_LIGHT: 'hover:bg-gray-50',
  HOVER_DARK: 'hover:bg-gray-100',
  ACTIVE_LIGHT: 'active:bg-gray-100',
  ACTIVE_DARK: 'active:bg-gray-200',
  
  
  LOADING_SPINNER: 'text-gray-600',
  SKELETON: 'bg-gray-200 animate-pulse',
};


export const COMPONENT_THEMES = {
  dialog: {
    overlay: 'bg-black/50',
    content: 'bg-white border border-gray-300',
    header: 'border-b border-gray-200',
    title: 'text-black font-semibold',
    description: 'text-gray-600',
  },
  
  card: {
    base: 'bg-white border border-gray-200 shadow-sm',
    header: 'border-b border-gray-100',
    content: 'text-gray-900',
  },
  
  table: {
    container: 'border border-gray-200 bg-white',
    header: 'bg-gray-50 border-b border-gray-200',
    headerCell: 'text-black font-medium',
    row: 'border-b border-gray-100 hover:bg-gray-50',
    cell: 'text-gray-900',
  },
  
  form: {
    label: 'text-black font-medium',
    input: 'border-gray-300 focus:border-black focus:ring-gray-400 bg-white text-black',
    select: 'border-gray-300 focus:border-black focus:ring-gray-400 bg-white text-black',
    error: 'text-gray-700 bg-gray-100 border-gray-300',
    success: 'text-gray-700 bg-gray-50 border-gray-200',
    description: 'text-gray-500',
  },
  
  badge: {
    base: 'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium',
    variants: {
      default: 'bg-gray-100 text-gray-900',
      secondary: 'bg-gray-800 text-white',
      outline: 'border border-gray-300 text-gray-900',
    },
  },
};


export const getStatusThemeClass = (metaStatus) => {
  const statusMap = {
    'NEW': THEME_CLASSES.STATUS_NEW,
    'IN_PROGRESS': THEME_CLASSES.STATUS_IN_PROGRESS,
    'WAITING': THEME_CLASSES.STATUS_WAITING,
    'DONE': THEME_CLASSES.STATUS_DONE,
  };
  
  return statusMap[metaStatus] || THEME_CLASSES.STATUS_NEW;
};

export const getButtonThemeClass = (variant = 'primary') => {
  const variantMap = {
    primary: THEME_CLASSES.BUTTON_PRIMARY,
    secondary: THEME_CLASSES.BUTTON_SECONDARY,
    ghost: THEME_CLASSES.BUTTON_GHOST,
  };
  
  return variantMap[variant] || THEME_CLASSES.BUTTON_PRIMARY;
};

export default {
  THEME_COLORS,
  SEMANTIC_COLORS,
  THEME_CLASSES,
  COMPONENT_THEMES,
  getStatusThemeClass,
  getButtonThemeClass,
}; 
